export default "__VITE_ASSET__BxI_KenH__"